
<template>
  <v-app id="onVttk">
    <v-main>
    <v-container fluid>  
    <v-card flat>
      <v-card-title>
        <div style="display: flex; flex-direction: row; align-items: center;">Code: {{vttk.vttk_code}} -- {{vttk.vttk_oms}} <v-btn small color="primary" @click="saveAll" class="ml-4">Save All</v-btn></div>
      </v-card-title>
      <div v-for="(vrtkRecord,i) in vttk.vrtk" :key="i" class="px-4">
        <div style="display: flex; flex-direction: row; align-items: center; margin-bottom: 15px; margin-top: 10px;">
            <div style="font-weight: bold; font-size: x-large">{{vrtkRecord.taal_code}}</div>
            <v-btn class="primary ml-4" small @click="saveVrtk(vrtkRecord)">Save</v-btn>
        </div>
        <v-textarea v-model="vrtkRecord.vrtk_vertaling" :value=vrtkRecord.vrtk_vertaling rows="5" label="Translation"></v-textarea>
      </div>  

    </v-card>  
    </v-container>
    </v-main>
    <navBar title="Ares - Reference data" :home="true" type="referencedata"/> 
  </v-app>
</template>


<script>
import navBar from "@/components/ui/navbars/navbar.vue";
 export default {
  components: {
    navBar
  },
  props: ['vttk_encrid'],
  data() {
    return {
      vttk: {}
    }  
  },
  mounted() {
      this.$axios
        .post("ares/json/ares/syst/ref/vttk/getVttk.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "getVttk"
          },
          getVttk: {
             vttk_encrid: this.vttk_encrid
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          } else {
            this.vttk = res.data.getVttk;
            document.title = "ARES - Text (" + this.vttk.vttk_code  + ")"
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
  methods: {
    saveAll(){
      this.vttk.vrtk.forEach(element => {
        this.saveVrtk(element)
      });
    },    
    saveVrtk(vrtk) { 
      this.$axios
        .post("ares/json/ares/syst/ref/vttk/saveVrtk.p", {
          header: {
            token: this.$session.get("ARES"),
            clientSessionId: this.$session.id(),
            request: "saveVrtk"
          },
          saveVrtk: {
            vrtk: vrtk
          }
        })
        .then(res => {
          if (res.data.error) {
            console.log(res.data.error);
          }  else {
            this.$store.dispatch('setSnackbar', {
              showing: true,
              text: res.data.saveVrtk.text,
              color: res.data.saveVrtk.color
            });
          }
        })
    }
  }  

};

</script> 
